import React from 'react'
import { useInfoValue, JobTitle } from '../Contexts/InfoContext'

export const TemplateFour = () => {
	const { data } = useInfoValue()

	const telOfficeNumber = data.officePhone ? data.officePhone : '310.376.7800';
	const telMobileNumber = data.mobilePhone ? data.mobilePhone : null;

	return (

	<table id="signatureMarkup" cellPadding="0" cellSpacing="0" style={{verticalSpacing: '-webkit-baseline-middle', fontSize: 'medium', fontFamily: 'Arial, Helvetica, sans-serif'}}>
		<tbody>
			<tr>
				<td style={{verticalAlign: 'top', display: 'block'}}>
					<table cellPadding="0" cellSpacing="0" style={{verticalAlign: '-webkit-baseline-middle', fontSize: 'medium', padding: '0', margin: '0'}}>
						<tbody>
							<tr>
								<td style={{textAlign: 'left'}}>
									<a href="https://venturablvd.goldenstate.is/" target="_blank" rel="noopener noreferrer">
										<img width="150" src="https://tgscdn.sfo2.cdn.digitaloceanspaces.com/email-signatures/logo-vb.png" alt="Ventura Blvd" role="presentation" style={{maxWidth: '150px', display: 'block', marginBottom: '20px'}} />
									</a>

									<h3 color="#181818" style={{color: '#181818', margin: '0', textTransform: 'Capitalize', fontSize: '16px', textAlign: 'left', font: 'bold', fontFamily: 'Arial, Helvetica, sans-serif'}}>
										<span>{data.firstName ? data.firstName : 'Michael'}</span>
										<span>&nbsp;</span>
										<span>{data.lastName ? data.lastName : 'Scott'}</span>
									</h3>
									<JobTitle />
								</td>
								<td width="30"><div>&nbsp;</div></td>
							</tr>
						</tbody>
					</table>
				</td>

				<td style={{padding: '0px', verticalAlign: 'middle'}}>
					<table cellPadding="0" cellSpacing="0" style={{verticalAlign: '-webkit-baseline-middle', fontSize: 'medium', display: 'inline-block'}}>
						<tbody>
							<tr style={{textAlign: 'center', display: 'block', marginBottom: '15px', marginTop: '5px'}}>
								<td style={{ padding: '0 5px 0 0' }}>
									<a href="https://www.facebook.com/OurVenturaBlvd/" target="_blank" rel="noopener noreferrer" style={{display: 'inline-block', padding: '0px', verticalAlign: 'top', lineHeight: '10px'}}>
										<img height="20" src="https://tgscdn.sfo2.cdn.digitaloceanspaces.com/email-signatures/facebook%20icon.png" alt="facebook" style={{ maxWidth: '135px', display: 'block'}} />
									</a>
								</td>

								<td style={{ padding: '0 5px' }}>
									<a href="https://www.instagram.com/OurVenturaBlvd/" target="_blank" rel="noopener noreferrer" style={{display: 'inline-block', padding: '0px', verticalAlign: 'top', lineHeight: '10px'}}>
										<img height="20" src="https://tgscdn.sfo2.cdn.digitaloceanspaces.com/email-signatures/instagram%20icon.png" alt="instagram" style={{ maxWidth: '135px', display: 'block'}} />
									</a>
								</td>

								<td style={{ padding: '0 5px' }}>
									<a href="https://twitter.com/OurVenturaBlvd" target="_blank" rel="noopener noreferrer" style={{display: 'inline-block', padding: '0px', verticalAlign: 'top', lineHeight: '10px'}}>
										<img height="20" src="https://tgscdn.sfo2.cdn.digitaloceanspaces.com/email-signatures/twitter%20icon.png" alt="twitter" style={{ maxWidth: '135px', display: 'block'}} />
									</a>
								</td>

								<td style={{ padding: '0 5px' }}>
									<a href="https://www.youtube.com/channel/UCzUaSdQWUZpra1h_brnmUAQ" target="_blank" rel="noopener noreferrer" style={{display: 'inline-block', padding: '0px', verticalAlign: 'top', lineHeight: '10px'}}>
										<img height="20" src="https://tgscdn.sfo2.cdn.digitaloceanspaces.com/email-signatures/youtube%20icon.png" alt="youtube" style={{ maxWidth: '135px', display: 'block'}} />
									</a>
								</td>

							</tr>
						</tbody>
					</table>
					
					<table cellPadding="0" cellSpacing="0" style={{fontSize: 'medium', marginLeft: '7px'}}>
						<tbody>
							<tr style={{verticalAlign: 'middle'}}>
								<td style={{padding: '12px 0 0', minWidth: '20px'}}>

									<table cellPadding="0" cellSpacing="0" style={{fontSize: 'medium'}}>
										<tbody>
											<tr>
												<td style={{fontSize: '11px', color: '#808080', lineHeight: '15px', textDecoration: 'none', marginRight: '5px', display: 'block'}}>
													<span>
														o.&nbsp;
													</span>
												</td>

												<td style={{fontSize: '11px', color: '#808080', lineHeight: '15px', textDecoration: 'none', minWidth: '70px'}}>
													<span>
														<a style={{textDecoration: 'none', color: '#808080'}} href={`tel:${telOfficeNumber}`}>{telOfficeNumber}</a>
													</span>
												</td>
											</tr>
										</tbody>
									</table>

								</td>
								<td style={{padding: '12px 0 0', minWidth: '20px'}}>
									{data.mobilePhone ?
									<table cellPadding="0" cellSpacing="0" style={{fontSize: 'medium'}}>
										<tbody>
											<tr>
												<td style={{fontSize: '11px', color: '#808080', lineHeight: '15px', textDecoration: 'none', marginRight: '5px', marginLeft: '10px', display: 'block'}}>
													<span>
														&nbsp;&nbsp;m.&nbsp;
													</span>
												</td>

												<td style={{fontSize: '11px', color: '#808080', lineHeight: '15px', textDecoration: 'none', minWidth: '70px'}}>
													<span>
														<a style={{textDecoration: 'none', color: '#808080'}} href={`tel:${telMobileNumber}`}>{telMobileNumber}</a>
													</span>
												</td>
											</tr>
										</tbody>
									</table>
									: null}
								</td>
							</tr>
						</tbody>
					</table>

					<table cellPadding="0" cellSpacing="0" style={{fontSize: 'medium', marginLeft: '7px'}}>
						<tbody>
							<tr style={{verticalAlign: 'middle'}}>
								<td style={{padding: '5px 0 0', fontSize: '11px', color: '#808080', lineHeight: '15px', textDecoration: 'none'}}>
									<a href="https://venturablvd.goldenstate.is/" target="_blank" rel="noopener noreferrer" color="#808080" style={{textDecoration: 'none', color: '#808080'}}>
										<span>venturablvd.goldenstate.is</span>
									</a>
								</td>
							</tr>

							<tr style={{verticalAlign: 'middle'}}>
								<td style={{padding: '5px 0 0', fontSize: '11px', color: '#808080', lineHeight: '14px', textDecoration: 'none'}}>
									<a href="https://goo.gl/maps/rv7LkPoEKydiyFvf6" target="_blank" rel="noopener noreferrer" color="#808080" style={{textDecoration: 'none', color: '#808080'}}>
										<span>200 N. Pacific Coast Hwy, Suite 110</span>
										<br />El Segundo, California, 90245</a>
									</td>
								</tr>
							</tbody>
						</table>

						<table cellPadding="0" cellSpacing="0">
							<tbody>
								<tr>
									<td style={{display: 'block', width: '99.9', clear: 'both'}} height="10px"><div>&nbsp;</div></td>
								</tr>
							</tbody>
						</table>

						<table cellPadding="0" cellSpacing="0" style={{verticalAlign: '-webkit-baseline-middle', fontSize: 'medium', marginLeft: '7px'}}>
							<tbody>
								<tr>
									<td style={{padding: '0'}}>
										<table cellPadding="0" cellSpacing="0" style={{verticalAlign: 'top', fontSize: 'medium', fontFamily: 'Arial', width: '100%', textAlign: 'right'}}>
											<tbody>
												<tr>
													<td width="35" align="left" style={{textAlign: 'left', verticalAlign: 'top'}}>
														<a href="https://thegoldenstatecompany.com/">
															<img width="35" src="https://tgsc.dev/email-signature-builder/logo-tgsc-footer.png" role="presentation" style={{maxWidth: '35px', display: 'block'}} alt="gsco logo" />
														</a>
													</td>
													<td width="5"><div>&nbsp;</div></td>
												</tr>
											</tbody>
										</table>
									</td>
									<td>
										<table cellPadding="0" cellSpacing="0" style={{verticalAlign: 'top', fontFamily: 'Arial', display: 'inline-block', textAlign: 'right'}}>
											<tbody>
												<tr style={{textAlign: 'right'}}>
													<td align="right" style={{padding: '0', textAlign: 'left', font: 'bold', lineHeight: '14px', color: '#808080', fontSize: '10px'}}>
														<span style={{whiteSpace: 'nowrap'}}>Moontide is a wholly owned subsidiary of</span>
														<br />
														The Golden State Company
													</td>
												</tr>
											</tbody>
										</table>
									</td>
								</tr>
							</tbody>
						</table>
					</td>
				</tr>
			</tbody>
		</table>

		)
	}